import React from 'react';
import PropTypes from 'prop-types';

const ExternalLink = (props) => {
  const {
    host,
    path,
    label,
  } = props;

  const href = `${host}${path}`;

  return (
    <a style={{ color: 'blue' }} href={href} target="_blank" rel="noreferrer">{label}</a>
  );
};

ExternalLink.propTypes = {
  host: PropTypes.string,
  path: PropTypes.string,
  label: PropTypes.string,
};

export default ExternalLink;
